import type { Maybe } from '@adornis/base/utilTypes.js';
import { ID } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';

/**
 * What the Austrittsassistent ends: the form of its dialog and the argument of its mutation.
 */
@Entity()
export class StudentExitOptions extends AdornisEntity {
  static override _class = 'StudentExitOptions';

  constructor(doc: PartialEntityData<StudentExitOptions>) {
    super(doc);
  }

  @Field(() => ID)
  personID: Maybe<string>;

  /** The last day the student is a member - inclusive, a canonical calendar day like every booking end. */
  @Field(() => Date)
  endDate: Maybe<Date>;

  /**
   * The bookings switched on in the dialog. The rules only pick the defaults (`getExitDefault`), the
   * server ends exactly these - as far as they still run on the end date.
   */
  @Field(() => [ID], { default: v => v ?? [] })
  bookingIDs: Maybe<string[]>;
}
